module.exports = __webpack_public_path__ + "static/media/esri-streets.310d4c98.png";